import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
  slots: {
    base: "mt-5 mb-4 lg:my-[16rem] grid grid-cols-4 gap-x-2 lg:grid-cols-6 lg:gap-x-4 mx-2 lg:mx-4",
    header: "col-span-4 lg:col-span-6",
    list: "col-span-4 lg:col-span-6 grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-y-3 gap-x-2 lg:gap-y-4  lg:gap-x-4 mt-3 lg:mt-4",
		listItems: "col-span-3 md:col-span-2",
  },
})

export type StylesVariants = VariantProps<typeof styles>
